import { useTheme } from 'contexts'
import React from 'react'

import { Box } from 'widgets/Box'
import { ControlProps } from 'widgets/Field/types'
import { Pressable } from 'widgets/Pressable'
import { Text } from 'widgets/Text'

import { StyledButtonContainer, StyledTextInput } from './styled'

export const InputAction = ({
  action,
  actionContent,
  inputProps,
  value,
  disabled,
  type = 'dark',
}: {
  action: () => void
  actionContent: string | React.ReactNode
  inputProps?: Partial<ControlProps>
  disabled?: boolean
  value: string
  type?: 'light' | 'dark'
}) => {
  const theme = useTheme()

  return (
    <Box flexDirection='row'>
      <Box flex={1}>
        <StyledTextInput value={value} type={type} {...inputProps} />
      </Box>
      <Box justifyContent='center'>
        <Pressable onPress={action} disabled={disabled}>
          <StyledButtonContainer disabled={disabled} padding='md'>
            {typeof actionContent === 'string' ? (
              <Text fontSize='sm' bold color='black'>
                {actionContent}
              </Text>
            ) : (
              actionContent
            )}
          </StyledButtonContainer>
        </Pressable>
      </Box>
    </Box>
  )
}
